import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";

export default function PagoExitoso() {

  const navigate = useNavigate();
  const mostrado = useRef(false);

  const [modal, setModal] = useState({
    visible: false,
    mensaje: "",
    onConfirm: () => {}
  });

  useEffect(() => {

    if (mostrado.current) return;
    mostrado.current = true;

    setModal({
      visible: true,
      mensaje: "🎉 Pago aprobado!\n\nTus puntos fueron acreditados.",
      onConfirm: () => navigate("/")
    });

  }, []);

  return (
    <>
      {/* Modal */}
      {modal.visible && (
        <div className="modal-backdrop">
          <div className="modal">

            <p>{modal.mensaje}</p>

            <div className="modal-actions">
              <button
                className="card-btn card-btn-primary glow-btn"
                onClick={modal.onConfirm}
              >
                Continuar
              </button>
            </div>

          </div>
        </div>
      )}
    </>
  );
}